<template>
  <!-- 操作失败、查看备注、下载实验数据提示 -->
  <el-dialog
    :title="info.title"
    :visible.sync="dialogVisible"
    :width="info.width"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="info.showClose"
    append-to-body
  >
    <div class="confirmtips" :style="{fontSize: info.fontSize ? info.fontSize : '16px'}">
      <i :class="info.icon" v-if="info.icon"></i>
      <span style="margin-left: 10px">{{info.tips}}{{form.checkRemark}}</span>
    </div>
    <div style="text-align: center;margin-top: 40px">
      <el-button
        v-show="info.showTimeout"
        @click="close()"
        size="small"
        :disabled="!show"
        type="primary"
      >
        我知道了
        <span v-if="count > 0">({{count}}S)</span>
      </el-button>
      <el-button v-show="!info.showTimeout" @click="close()" size="small" type="primary">我知道了</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { setAdministrator } from "@/api/request";
export default {
  data() {
    return {
      dialogVisible: false,
      show: true,
      count: "",
      timer: null,
      form: {},
      info: {}
    };
  },
  methods: {
    init(row, info) {
      this.dialogVisible = true;
      this.form = row;
      this.$nextTick(() => {
        this.info = info;
        if (info.showTimeout) {
          const TIME_COUNT = 5;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped>
.el-icon-warning {
  font-size: 30px;
  color: #e6a23c;
}
.confirmtips {
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
}
</style>